function initials(name?: string): string {
  if (!name) return "?";
  return name
    .trim()
    .split(/\s+/)
    .map((part) => part[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

// Deterministic colour from the name so the same person is always the same hue.
const COLORS = [
  "bg-rose-500",
  "bg-amber-500",
  "bg-emerald-500",
  "bg-sky-500",
  "bg-indigo-500",
  "bg-fuchsia-500",
  "bg-teal-500",
];
function colorFor(name?: string): string {
  let hash = 0;
  const value = name || "";
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) % COLORS.length;
  }
  return COLORS[Math.abs(hash) % COLORS.length];
}

interface MemberAvatarProps {
  name?: string;
  title?: string;
}

export default function MemberAvatar({ name, title }: MemberAvatarProps) {
  return (
    <span
      title={title || name || ""}
      className={`inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-[11px] font-semibold text-white ring-2 ring-white ${colorFor(
        name
      )}`}
    >
      {initials(name)}
    </span>
  );
}
